module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        backText: ""
      }
    }
  }, [_vm._v("\n      目录读写权限管理\n    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group-list domain-list"
  }, [_c('div', {
    staticClass: "form-group margin-bottom-20"
  }, [_c('div', {
    staticClass: "form-group-item"
  }, [_c('span', {
    staticClass: "form-label"
  }, [_vm._v("\n\t\t\t\t\t\t全局写入权限\n\t\t\t\t\t")]), _vm._v(" "), _c('inline-x-switch', {
    staticStyle: {
      "margin-top": "0.12rem"
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1)])]), _vm._v(" "), _c('x-button', {
    staticStyle: {
      "background-color": "#00aaff",
      "color": "#fff",
      "margin-top": ".2rem",
      "margin-bottom": ".3rem",
      "width": "97%"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submit1($event)
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('div', {
    staticClass: "form-group-list domain-list"
  }, [_c('div', {
    staticClass: "form-group margin-bottom-20"
  }, [_c('div', {
    staticClass: "form-group-item"
  }, [_c('span', {
    staticClass: "form-label"
  }, [_vm._v("\n\t\t\t\t\t\t单独设置权限\n\t\t\t\t\t")]), _vm._v(" "), _c('inline-x-switch', {
    staticStyle: {
      "margin-top": "0.12rem"
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group-item"
  }, [_c('x-input', {
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "label-width": "8em",
      "title": "文件夹：\\web\\",
      "placeholder": "请输入文件夹路径"
    },
    model: {
      value: (_vm.dirPathInput),
      callback: function($$v) {
        _vm.dirPathInput = $$v
      },
      expression: "dirPathInput"
    }
  })], 1)])]), _vm._v(" "), _c('x-button', {
    staticStyle: {
      "background-color": "#FF6600",
      "color": "#fff",
      "margin-top": ".2rem",
      "width": "97%"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submit2($event)
      }
    }
  }, [_vm._v("确定")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mui-inner-wrap"
  }, [_c('div', {
    staticClass: "alert-warn margin-bottom-20 domain-list"
  }, [_c('p', {
    staticClass: "line-left-dot"
  }, [_vm._v("关闭写入权限，锁定虚拟主机，对安全有重要意义。建议按照以下步骤设置网站：")]), _vm._v(" "), _c('p', {
    staticClass: "line-left-dot"
  }, [_vm._v("关闭全局写入权限")]), _vm._v(" "), _c('p', {
    staticClass: "line-left-dot"
  }, [_vm._v("对于特定需要写入内容的文件夹，打开写入权限。")]), _vm._v(" "), _c('p', {
    staticClass: "line-left-dot"
  }, [_vm._v("对已经打开写入权限的文件夹，使用控制面板的“执行权限”功能，关闭执行权限。")]), _vm._v(" "), _c('p', {
    staticClass: "line-left-dot"
  }, [_vm._v("按照如上设置，您的网站安全性会大大提高")]), _vm._v(" "), _c('p', {
    staticClass: "line-left-dot"
  }, [_vm._v("如果您的网站文件数量很多，更改写入权限可能需要比较长的时间，请耐心等待。")]), _vm._v(" "), _c('p', {
    staticClass: "line-left-dot"
  }, [_vm._v("关闭写入权限后，您的FTP和子站点也将同时关闭写入权限。")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39acb666","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/console/hostoperate/dirauth.vue
// module id = G9K5
// module chunks = 1